/**
 * Health monitor (Story 306).
 *
 * Pure-data, framework-free buffer that maintains the last N latency
 * samples and the last M rate-limit events. The view uses Vue refs to
 * subscribe; this file contains no Vue imports so unit tests can exercise
 * the buffers independently.
 */

export const DEFAULT_LATENCY_WINDOW = 60;
export const DEFAULT_RATE_LIMIT_HISTORY = 10;

export interface LatencySample {
  timestamp: number;
  latencyMs: number;
  ok: boolean;
}

export interface RateLimitEvent {
  timestamp: number;
  retryAfterMs: number;
}

export class HealthMonitor {
  private samples: LatencySample[] = [];
  private rateLimitEvents: RateLimitEvent[] = [];

  constructor(
    private readonly latencyWindow = DEFAULT_LATENCY_WINDOW,
    private readonly rateLimitWindow = DEFAULT_RATE_LIMIT_HISTORY,
  ) {}

  recordLatency(sample: LatencySample): void {
    this.samples.push(sample);
    if (this.samples.length > this.latencyWindow) {
      this.samples.splice(0, this.samples.length - this.latencyWindow);
    }
  }

  recordRateLimit(event: RateLimitEvent): void {
    this.rateLimitEvents.push(event);
    if (this.rateLimitEvents.length > this.rateLimitWindow) {
      this.rateLimitEvents.splice(0, this.rateLimitEvents.length - this.rateLimitWindow);
    }
  }

  getSamples(): ReadonlyArray<LatencySample> {
    return this.samples.slice();
  }

  getRateLimits(): ReadonlyArray<RateLimitEvent> {
    return this.rateLimitEvents.slice();
  }

  reset(): void {
    this.samples = [];
    this.rateLimitEvents = [];
  }
}
